/**
 * Цвета проектов — единый источник истины.
 * Фон строк таблицы по статусу, бейджи (фон = цвет строки, текст темнее), цвета типов проекта (project_type).
 */

/** Пастельный оранжевый: фон строки каталога чтецов «Разово» (--readers-catalog-cooperation-razovo-bg). */
export const READER_COOPERATION_RAZOVO_ROW_BACKGROUND = '#FFE5D0';

/** Цвет фона строки таблицы по базовому статусу проекта */
export const STATUS_ROW_BACKGROUND: Record<string, string> = {
  Запись: '#FFEFC4',
  Монтаж: '#d1d9ff',
  Проверка: '#e1cfff',
  'Проверка правок': '#e1cfff',
  Правки: '#e6c1ed',
  Готов: '#D1F8B2',
  Добавлен: '#ffffff',
};

/** Базовый цвет строки по умолчанию (если статус неизвестен) */
const DEFAULT_ROW_BACKGROUND = '#ffffff';

/** Цвета типов проекта (project_type) — бейдж в ячейке name и др. */
export const PROJECT_TYPE_COLORS: Record<string, string> = {
  Author: '#90CAF9',
  Podcast: '#F28B82',
  Azbooka: '#bc71c9',
  Special: '#FFC107',
  AudioDrama: '#7E57C2',
  AI: '#66BB6A',
  Common: '#BDBDBD',
};

const DEFAULT_PROJECT_TYPE_COLOR = '#BDBDBD';

/** Цвет типа проекта (символ/иконка). */
export function getProjectTypeColor(type: string | null | undefined): string {
  if (!type?.trim()) return DEFAULT_PROJECT_TYPE_COLOR;
  return PROJECT_TYPE_COLORS[type.trim()] ?? DEFAULT_PROJECT_TYPE_COLOR;
}

/** Немного затемнить hex-цвет (для текста на бейдже). pct — доля затемнения 0..1 */
export function darkenHex(hex: string, pct: number = 0.2): string {
  const n = hex.replace(/^#/, '');
  const r = Math.max(0, Math.round(parseInt(n.slice(0, 2), 16) * (1 - pct)));
  const g = Math.max(0, Math.round(parseInt(n.slice(2, 4), 16) * (1 - pct)));
  const b = Math.max(0, Math.round(parseInt(n.slice(4, 6), 16) * (1 - pct)));
  return '#' + [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('');
}

/** Альфа фона бейджа типа в ячейке названия (непрозрачность заливки, 0..1). */
const PROJECT_TYPE_BADGE_BG_OPACITY = 0.6;
const PROJECT_TYPE_BADGE_BG_ALPHA = Math.round(PROJECT_TYPE_BADGE_BG_OPACITY * 255)
  .toString(16)
  .padStart(2, '0');

/** Бейдж типа только в ячейке названия: полупрозрачный фон, текст темнее базового цвета типа. */
export function getProjectTypeBadgeColor(type: string | null | undefined): {
  bg: string;
  color: string;
} {
  const base = getProjectTypeColor(type);
  const rgb = base.replace(/^#/, '');
  return {
    bg: `#${rgb}${PROJECT_TYPE_BADGE_BG_ALPHA}`,
    color: darkenHex(base, 0.5),
  };
}

/**
 * Цвет фона строки по базовому статусу.
 * Используется в таблице проектов и как фон бейджа.
 */
export function getRowBackgroundByBase(baseStatus: string): string {
  return STATUS_ROW_BACKGROUND[baseStatus] ?? DEFAULT_ROW_BACKGROUND;
}

/**
 * Цвета бейджа статуса: фон = цвет строки, текст чуть темнее.
 */
export function getStatusBadgeColorByBase(baseStatus: string): { bg: string; color: string } {
  const bg = getRowBackgroundByBase(baseStatus);
  const color = darkenHex(bg, 0.35);
  return { bg, color };
}

